import styled from 'styled-components';

import { fonts, colors } from 'stylesheets';

export const Content = styled.div`
  p {
    text-align: center;
    font-size: 17px !important;
  }
`;

export const ContentText = styled.p`
  margin: 40px 10% 10px;
`;

export const Button = styled.div`
  width: 30%;
  height: auto;
  margin: 0 auto;
  margin-top: 35px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: ${({ backgroundColor }) => {
    switch (backgroundColor) {
      case 'primary':
        return colors.primary;
      case 'greyLight':
        return colors.greyLight;
      case 'red':
        return colors.red;
      default:
        return colors.greyLight;
    }
  }};
  box-shadow: 0px 1px 4px ${colors.greyLight};
  text-align: center;
  color: ${colors.white};
  text-transform: uppercase;
  cursor: ${({ cursor }) => cursor};
  font: 800 15px/30px ${fonts.secondary};
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;

export const BackButton = styled.span`
  color: ${colors.primary};
  font: 13px ${fonts.secondary};
  cursor: pointer;
  &:hover {
    font-weight: 800;
  }
`;

export const ExternalCode = styled.div`
  margin: 10px 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & div {
    max-width: 100% !important;
  }
`;
